'use client';
import { jsx } from 'react/jsx-runtime';
import { useFloatingLabelLabelProps } from '../../contexts/internal/floating-label/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(o = 0; o < l.length; o++)t = l[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, l = Object.keys(e);
    for(o = 0; o < l.length; o++)t = l[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const DropdownFloatingLabel = renderWithRef('DropdownFloatingLabel', null, (t, n)=>{
    var { children: l } = t;
    return jsx(RenderComp, {
        root: "label",
        classNames: [
            'swan-dropdown-floating-label'
        ],
        forwardedRef: n,
        props: _object_spread({}, _object_without_properties(t, [
            "children"
        ]), useFloatingLabelLabelProps()),
        children: l
    });
});

export { DropdownFloatingLabel };
